/* INDIGREY — image-loading indicator, site-wide (pairs with ig-img-loader.css).
   Marks every still-loading content photograph with .ig-imgload so the CSS
   shuttle line shows, and removes it the instant the image lands or fails.
   Scope guards: only images inside #MainContent (never header/nav/footer
   chrome), and never boxes narrower than ~70px (icons, seals). Watches the
   DOM for late arrivals — AJAX grids, Swiper clones, and lazily hydrated
   strips that receive their src after first paint. */
(function () {
  function eligible(img) {
    if (!img || img.tagName !== 'IMG') return false;
    if (img.closest('#sticky-header, #page-header, header, nav, .ig-rd-header')) return false;
    if (!img.closest('#MainContent')) return false;
    var r = img.getBoundingClientRect();
    var bw = r.width || parseInt(img.getAttribute('width') || '0', 10);
    if (bw && bw < 70) return false;
    return true;
  }
  function mark(img) {
    if (!eligible(img)) return;
    if (img.complete && img.naturalWidth > 0) { img.classList.remove('ig-imgload'); return; }
    if (!img.getAttribute('src') && !img.currentSrc) return;   /* deferred frames join when hydrated */
    img.classList.add('ig-imgload');
  }
  function clear(e) {
    var t = e.target;
    if (t && t.tagName === 'IMG') t.classList.remove('ig-imgload');
  }
  document.addEventListener('load', clear, true);
  document.addEventListener('error', clear, true);
  function scan(root) {
    (root || document).querySelectorAll('img').forEach(mark);
  }
  var mo = new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      if (m.type === 'attributes') { mark(m.target); return; }
      if (!m.addedNodes) return;
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') mark(n);
        else if (n.querySelectorAll) n.querySelectorAll('img').forEach(mark);
      }
    });
  });
  function boot() {
    scan();
    if (document.body) {
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
